"use strict";var e=require("react"),r=require("styled-components");function o(e){return e&&"object"==typeof e&&"default"in e?e:{default:e}}var t=o(e),a=o(r);const i=r.keyframes`
    0% {
        transform: rotateZ(0deg);
    }
    100% {
        transform: rotateZ(360deg)
    }
`,s=r.keyframes`
    0% {
        transform: rotate(0);
    }
    50%{
        transform: rotate(180deg);
    }
    100% {
        transform: rotate(360deg);
    }
`,l=r.css`
    animation: 2s linear infinite ${i};
`,n=r.css`
    animation: 10s ease-in-out infinite both ${s};
`,d={xSmall:"22.63px",small:"22.63px",medium:"25.46px",large:"34px"},c=a.default.svg`
    width: ${({size:e})=>d[e]};
    ${l}
`,f=a.default.circle`
    display: block;
    fill: none;
    stroke: ${({theme:e,type:r,isDisabled:o,foregroundColor:t})=>e.colors[e.colorMode][((e,r,o)=>o||(r||"secondary"===e?"primary":"specialPositive"===e?"special_positive":"tertiaryLow"===e?"background_inverse_Primary":"background_Primary"))(r,o,t)]};
    stroke-linecap: round;
    stroke-dasharray: 210;
    stroke-dashoffset: 190;
    stroke-width: 4px;
    transform-origin: 50% 50%;
    ${n}
`,m=a.default.circle`
    display: block;
    fill: none;
    stroke: ${({theme:e,type:r,isDisabled:o,backgroundColor:t})=>e.colors[e.colorMode][((e,r,o)=>o||(r||["positive","primary","secondary","tertiaryLow","specialPositive"].includes(e)?"text_disabled":"text_inverse_disabled"))(r,o,t)]};
    stroke-width: 4px;
    transform-origin: 50% 50%;
`;exports.Loader=({size:e,type:r,isDisabled:o,backgroundColor:a,foregroundColor:i})=>t.default.createElement(c,{size:e,type:r,viewBox:"0 0 24 24"},t.default.createElement(m,{type:r,isDisabled:o,backgroundColor:a,cx:"12",cy:"12",r:"8"}),t.default.createElement(f,{type:r,isDisabled:o,foregroundColor:i,cx:"12",cy:"12",r:"8"}));
//# sourceMappingURL=index.js.map
